'use client';

import React from 'react';

import ListPage from '../../../../../components/page-components/list-page/list-page';
import { createListCardArray } from '../../../../../helpers/list-page/list-page-helpers';
import { pageIsNewsItem } from '../../../../../helpers/list-page/type-guards';
import useGetMobileAppWebViewHeader from '../../../../../hooks/use-get-mobile-app-web-view';
import { IMeetingPlacePageOccations } from '@/lib/fragments/meetingPlacePageOccations';
import { IMeetingplacePageHomeMinifiedExtendedLogo } from '@/lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageNewsList } from '@/lib/fragments/meetingPlacePageNewsList';
import { useTenantConfig } from '@/providers/ConfigProvider';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageNewsListProps {
  metaData: any;
  node_locale: string;
  urlSubdirectory?: string;
  occasionId?: string;
  newsListData: {
    meetingPlacePageNewsList: IMeetingPlacePageNewsList | null;
    meetingPlacePageOccasions: IMeetingPlacePageOccations | null;
    meetingPlacePageHomeCollection: IMeetingplacePageHomeMinifiedExtendedLogo | null;
  };
  initialPage?: number;
}

const MeetingPlacePageNewsList = ({
  metaData,
  node_locale,
  urlSubdirectory,
  occasionId,
  newsListData,
  initialPage,
}: MeetingPlacePageNewsListProps) => {
  const config = useTenantConfig();
  const prefix = config?.GATSBY_SITE_PATH_PREFIX || '';
  const page = newsListData?.meetingPlacePageNewsList;
  const homepage = newsListData?.meetingPlacePageHomeCollection;
  const today = new Date();

  const newsItemPagesInOccasionList =
    newsListData?.meetingPlacePageOccasions?.occasionsCollection?.items
      ?.filter(Boolean) // removes null / undefined / false
      ?.filter(
        (t: any) =>
          pageIsNewsItem(t) &&
          t?.sys?.id &&
          (!t.hideInListFrom || new Date(t.hideInListFrom) > today),
      ) ?? [];

  const newsItemPages = newsItemPagesInOccasionList
    ? [...newsItemPagesInOccasionList]
    : [];

  page?.newsItemsCollection?.items?.filter(Boolean)?.forEach((page: any) => {
    const pageExists =
      newsItemPages.filter((item) => item?.sys?.id === page?.sys?.id).length >
      0;
    if (!pageExists) newsItemPages.push(page);
  });

  const newsItemCardList = createListCardArray(
    newsItemPages,
    undefined,
    undefined,
    urlSubdirectory,
    node_locale,
    prefix,
  );

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {page && (
        <>
          {/* ✅ GTM PAGE VIEW */}
          <GtmPageView
            homepage={homepage}
            language={node_locale}
            pageTitle={page?.name ?? ''}
          />

          <ListPage
            cardList={newsItemCardList}
            pageName={page?.name}
            pageSlug={page?.slug}
            node_locale={node_locale}
            breadcrumbs={[page?.name]}
            homeText={homepage?.breadcrumbHomeText ?? ''}
            tileColClass="grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
            listType="news"
            isWebView={isWebView}
            initialPage={initialPage ?? 1}
          />
        </>
      )}
    </>
  );
};

export default MeetingPlacePageNewsList;
